import { makeStyles } from '@material-ui/core';

export const useNotificationStyle = makeStyles(theme => ({
  acceptButton: {
    color: `${theme.palette.success.main} !important`,
  },
  rejectButton: {
    color: `${theme.palette.error.main} !important`,
  },
  avatar: {
    fontSize: '12px',
    marginRight: '12px',
    'div&': {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  },
  container: {
    marginBottom: '16px',
    borderBottom: '1px solid rgba(0,0,0,.12)',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  userProfileContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    letterSpacing: 'normal',
  },
  userProfileContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    margin: '16px 0',
    marginLeft: '36px',
  },
  contentElementHeader: {
    display: 'flex',
    marginBottom: '16px',
    flexDirection: 'column',
  },
  contentElementSpan: {
    position: 'relative',
    fontWeight: 'bold',
    color: 'rgba(0,0,0,.54)',
    fontSize: '14px',
    textTransform: 'uppercase',
  },
  contentElementMargin: {
    marginRight: '32px',
  },
  dialogHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogContentContainer: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    alignItems: 'center',
  },
  dialogContentHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  notificationsContainer: {
    margin: '0 auto',
    padding: '16px 0',
    width: '680px',
  },
  questionParentContainer: {
    margin: '16px 0',
  },
  questionContainer: {
    marginLeft: '36px',
  },
  question: {
    marginBottom: '16px',
  },
  dialogActionStyle: {
    paddingRight: '1.5rem',
    paddingBottom: '1rem',
  },
  highlightQuestion: {
    fontWeight: 400,
    marginBottom: '16px',
  },
  fullWidth: {
    width: '100%',
  },
  buttonsContainer: {
    padding: '16px 30px',
  },
  textFieldContainer: {
    marginLeft: '36px',
  },
  summaryHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: '20px',
    gap: '8px',
  },
  summaryDescription: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    '& svg': {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  summary: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  expandableDisclosureContainer: {
    width: '100%',
    boxShadow: 'none',
    border: '1px solid rgba(0,0,0,.12)',
    backgroundColor: 'inherit',
  },
  expandableSummaryHeaderOutsideDisclosure: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 16px',
    minHeight: '48px',
    width: '100%',
    backgroundColor: 'inherit',
  },
  expandableSummaryHeaderActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  disclosureToggleButton: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  disclosureToggleButtonExpanded: {
    transform: 'rotate(180deg)',
  },
  expandableSummaryBody: {
    display: 'flex',
    padding: '0 16px',
    minHeight: '48px',
    transition:
      'min-height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: 'transparent',
  },
  expandableSummaryBodyContent: {
    margin: '0px 0px 12px 0px',
    display: 'flex',
    overflow: 'auto',
    flexGrow: 1,
    transition: 'margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexDirection: 'column',
  },
  expandableSummaryNoTopBorder: {
    borderTop: 'none',
  },
  nonExpandableDisclosureRoot: {
    position: 'relative',
    transition: 'margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxShadow: 'none',
    borderBottom: '1px solid rgba(0,0,0,.12)',
    width: '100%',
    backgroundColor: 'inherit',
    borderRadius: 0,
  },
  nonExpandableDisclosureSummary: {
    display: 'flex',
    padding: '0 16px',
    minHeight: '48px',
    transition:
      'min-height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    cursor: 'default',
    userSelect: 'text',
    backgroundColor: 'transparent',
    border: '1px solid #eeeeee',
  },
  nonExpandableDisclosureContent: {
    margin: '12px 0',
    display: 'flex',
    overflow: 'auto',
    flexGrow: 1,
    transition: 'margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexDirection: 'column',
  },
  summaryDescriptionText: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(2),
    '& a': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
    },
  },
  notificationTime: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
  },
}));
